import { apiClient } from './client';
import type {
  Admin,
  AdminCreateInput,
  AdminUpdateInput,
} from '../../types/entities';

export const adminsApi = {
  /**
    * Get all admins
    * GET /admins
    */
  getAll: async (): Promise<Admin[]> => {
    return apiClient.get<Admin[]>('/admins');
  },

  /**
    * Get a single admin by ID
    * GET /admins/:id
    */
  getById: async (id: number): Promise<Admin> => {
    return apiClient.get<Admin>(`/admins/${id}`);
  },

  /**
    * Create a new admin
    * POST /admins
    */
  create: async (data: AdminCreateInput): Promise<Admin> => {
    return apiClient.post<Admin>('/admins', data);
  },

  /**
    * Update an admin
    * PUT /admins/:id
    */
  update: async (id: number, data: AdminUpdateInput): Promise<Admin> => {
    return apiClient.put<Admin>(`/admins/${id}`, data);
  },

  /**
    * Delete an admin
    * DELETE /admins/:id
    */
  delete: async (id: number): Promise<void> => {
    return apiClient.delete<void>(`/admins/${id}`);
  },
};
